import React from "react";

function Footer() {
  return (
    <>
      <section id="footer" className="footer"></section>
      <footer className="footer">
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} <strong>ReHome</strong> |{" "}
            <a href="/" aria-label="Privacy Policy">Privacy Policy</a> |{" "}
            <a href="/" aria-label="Terms of Service">Terms of Service</a>
          </p>
          <p>Follow us on social media:</p>
          <div className="social-links">
            <a href="https://www.instagram.com/_rehome_?igsh=MWdlbzk4NmR4dWNucw==" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook">
              Facebook
            </a>
            <span> | </span>
            <a href="https://www.instagram.com/_rehome_?igsh=MWdlbzk4NmR4dWNucw==" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram">
              Instagram
            </a>
            <span> | </span>
            <a href="https://www.instagram.com/_rehome_?igsh=MWdlbzk4NmR4dWNucw==" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Twitter">
              Twitter
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
